import RequeteToolbar from "./RequeteToolbar";
import RequeteEtatChip from "./RequeteEtatChip";

export default {
    install(Vue) {
        Vue.component("a-requete-toolbar", RequeteToolbar);
        Vue.component("a-requete-etat-chip", RequeteEtatChip);
    }
}
